import { render, staticRenderFns } from "./add-renting.vue?vue&type=template&id=166c096e&scoped=true"
import script from "./add-renting.vue?vue&type=script&lang=js"
export * from "./add-renting.vue?vue&type=script&lang=js"
import style0 from "./add-renting.vue?vue&type=style&index=0&id=166c096e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166c096e",
  null
  
)

export default component.exports